import { query, mutation } from '@/dex-shared/helpers/graphql';

export default {
  async DELETE_FILES_LINKED_TO_ASSIGNMENT_ID(
    _,
    { assignmentId }: { assignmentId: number },
  ) {
    const assignmentResponse = await query(
      `
      query getAssignmentById($assignmentId: Int!) {
        assignmentById(id: $assignmentId) {
          userId
          examByExamId {
            fileBoxesByExamId {
              nodes {
                id
              }
            }
          }
        }
      }
    `,
      {
        assignmentId,
      },
    );

    const assignment = assignmentResponse.data.assignmentById;

    if (!assignment) return;

    const userId = assignment.userId;
    const fileBoxIdList = assignment.examByExamId.fileBoxesByExamId.nodes.map(
      fileBox => fileBox.id,
    );

    const filesResponse = await query(
      `
      query filesByUserIdAndFileBoxIdList ($userId: Int!, $fileBoxIdList: [Int!]){
        allFiles(filter: {
          userId: {equalTo: $userId},
          fileBoxId: {in: $fileBoxIdList}
        }) {
          nodes {
            id
            userId
            fileBoxId
          }
        }
      }
    `,
      {
        userId,
        fileBoxIdList,
      },
    );

    if (!filesResponse) return;

    const files = filesResponse.data.allFiles.nodes;

    for (const file of files) {
      await mutation(
        `
        mutation deleteFileById($fileId: Int!) {
          deleteFileById(input: { id: $fileId }) {
            file {
              id
            }
          }
        }
      `,
        { fileId: file.id },
      );
    }
  },
};
